import api from "./api";

/**
 * `/admin/usage` (issue #1113, D427). `GET /api/admin/usage/report?weeks=N`
 * (#1112, extended by #1594). Admin-only. The numbers arrive already
 * suppressed ("fewer than 3" for a small count) and are shown as sent: this
 * module and its page never sum, round or infer a figure.
 */
export const PERIODS = [
  { weeks: 1, label: "This week" },
  { weeks: 4, label: "4 weeks" },
  { weeks: 8, label: "8 weeks" },
  { weeks: 12, label: "12 weeks" },
];

export async function fetchUsageReport(weeks) {
  const { data } = await api.get(`/admin/usage/report?weeks=${weeks}`);
  return data;
}
